<h1 mat-dialog-title class="col-12 dialog-filing-routeTitle">{{data.dialogTitle}}</h1>

<mat-form-field class="col-12">
  <input matInput [(ngModel)]="data.name" placeholder="Name">
</mat-form-field>
<mat-form-field class="col-12">
  <textarea matInput [(ngModel)]="data.descriptionText" placeholder="Description" cdkTextareaAutosize class="textArea"></textarea>
</mat-form-field>
<div class="col-12 mb-3">
  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="onClickCancel()"
            class="dialog-filing-routeCancelButton">Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="data" cdkFocusInitial class="dialog-filing-routeSaveButton">Ok</button>
  </mat-dialog-actions>
</div>
